import apiSportsSchools from '@/api/sports-schools'
import apiSportsFederations from '@/api/sports-federations'

const state = {
  data: [],
  isLoading: false,
  validationErrors: null,
}

export const mutationTypes = {
  getSchoolsStart: '[schools and federations] get schools Start',
  getSchoolsSuccess: '[schools and federations] get schools Success',
  getSchoolsFailure: '[schools and federations] get schools Failure',

  getFederationsStart: '[schools and federations] get federations Start',
  getFederationsSuccess: '[schools and federations] get federations Success',
  getFederationsFailure: '[schools and federations] get federations Failure',

  getSchoolsFederationsStart:
    '[schools and federations] get schools and federations Start',
  getSchoolsFederationsSuccess:
    '[schools and federations] get schools and federations Success',
  getSchoolsFederationsFailure:
    '[schools and federations]  schools and federations Failure',

  clearSchools: '[schools and federations] clear schools and federations',
}

export const actionTypes = {
  getSchools: '[schools and federations] get schools',
  getFederations: '[schools and federations] get federations',
  getSchoolsFederations:
    '[schools and federations] get schools and federations',
}

const mutations = {
  [mutationTypes.clearSchools](state) {
    state.isLoading = true
    state.data = []
    state.validationErrors = null
  },

  [mutationTypes.getSchoolsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSchoolsSuccess](state, payload) {
    const schools = payload.map((school) => ({type: 'school', ...school}))
    state.isLoading = false
    state.data = [...state.data, ...schools]
  },

  [mutationTypes.getSchoolsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.getFederationsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getFederationsSuccess](state, payload) {
    const federations = payload.map((federation) => ({
      type: 'federation',
      ...federation,
    }))
    state.isLoading = false
    state.data = [...state.data, ...federations]
  },

  [mutationTypes.getSchoolsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.getSchoolsFederationsStart](state) {
    state.data = []
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSchoolsFederationsSuccess](state) {
    state.isLoading = true
  },

  [mutationTypes.getSchoolsFederationsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionTypes.getSchools](context) {
    context.commit(mutationTypes.getSchoolsStart)
    return new Promise((resolve) => {
      apiSportsSchools
        .getSportSchools()
        .then((response) => {
          context.commit(mutationTypes.getSchoolsSuccess, response.data.list)
          resolve(response.data.list)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getSchoolsFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionTypes.getFederations](context) {
    context.commit(mutationTypes.getFederationsStart)
    return new Promise((resolve) => {
      apiSportsFederations
        .getSportFederations()
        .then((response) => {
          context.commit(mutationTypes.getFederationsSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getFederationsFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionTypes.getSchoolsFederations](context) {
    context.commit(mutationTypes.getSchoolsFederationsStart)
    return new Promise((resolve) => {
      context
        .dispatch(actionTypes.getSchools)
        .then(() => {
          return context.dispatch(actionTypes.getFederations)
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getSchoolsFederationsFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
